export default {
    handleErrosIntegracaoRnds(errorData, errorForm) {
        if (!errorForm) return;

        let error = errorData.errors;
        errorForm.error = '';

        if (typeof error === 'string') {
            errorForm.error = error;
            return;
        }

        if (typeof error === 'object') {
            const firstKey = Object.keys(error)[0];
            errorForm.error = error[firstKey]?.[0] ?? 'Erro desconhecido.';
        }
    }
}
